import { render } from "./RiskListModal.vue?vue&type=template&id=348c8254&scoped=true"
import script from "./RiskListModal.js?vue&type=script&lang=js"
export * from "./RiskListModal.js?vue&type=script&lang=js"

import "./RiskListModal.vue?vue&type=style&index=0&id=348c8254&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348c8254"]])

export default __exports__